import Vue from 'vue'
import loaderHandler from '@/mixins/loaderHandler'
import slotHandler from '@/mixins/slotHandler'
import toastHandler from '@/mixins/toastHandler'
import accessibleTextHandler from '@/mixins/accessibleTextHandler'

Vue.mixin({
  beforeCreate () {
    const _imports = this.$options.import
    if (_imports) {
      const keys = Object.keys(_imports)
      for (let i = 0; i < keys.length; i++) {
        this[keys[i]] = _imports[keys[i]]
      }
    }
  }
})

Vue.mixin(loaderHandler())
Vue.mixin(slotHandler())
Vue.mixin(toastHandler())
Vue.mixin(accessibleTextHandler())
